import React, { useState } from 'react';

import defaultImage from '../../../resources/images/chats/x2/emptyChat.jpg';
import Spinner from '../Spinner';
import styles from './styles.module.scss';

const ImageLoader = ({ src, alt, withDefault = true, loaderSize = 24 }) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [imageLoadingError, setImageLoadingError] = useState(false);

    const handleImageLoad = () => setIsLoaded(true);

    const handleImageError = () => {
        setIsLoaded(true);
        setImageLoadingError(true);
    };

    return (
        <>
            {!isLoaded && (
                <div className={styles.loader}>
                    <Spinner width={loaderSize} height={loaderSize} />
                </div>
            )}
            <img
                src={imageLoadingError && withDefault ? defaultImage : src}
                alt={alt}
                onLoad={handleImageLoad}
                onError={handleImageError}
                className={`${isLoaded ? styles.img : styles.none}`}
            />
        </>
    );
};

export default ImageLoader;
